import { Chip } from "@mui/material";
import styled from "styled-components";

export const ChipContainer = styled.div`
`;

export const StyledChip = styled(Chip)`
  && {
    font-size: 13px;
  }
`;
